export default [
  {
    id: 1,
    text: 'Diferença máxima entre preços das transportadoras',
    value: 'MAX_DIFFERENCE_BETWEEN_PROVIDER_SHIPPING_COST',
  },
];



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quoting-return/enum/EnumConditionalCustomParams.js